import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { Pricing, SeatsioSeatingChart, SelectableObject, SelectionLimiter } from '@seatsio/seatsio-react';

import Env from 'common/src/env';
import { EventTemplate } from 'common/src/models/event';

import ActionModal from '../../../components/ActionModal';

interface IProps {
  eventTemplate: EventTemplate;
  selectionLimiter: SelectionLimiter;
  onSeatSelectionChange: (ticketOptionId: string, isAdd: boolean, seatId: string) => void;
}
const SeatMap: React.FC<IProps> = ({ eventTemplate, selectionLimiter, onSeatSelectionChange }) => {
  const { t, i18n } = useTranslation('wbevt.events');

  const [showSeatBookedModal, setShowSeatBookedModal] = React.useState(false);

  const pricing: Pricing = eventTemplate.payload.hostedEventPayload.ticketOptions.map((ticket)=>{
    return { category: ticket.name, price: ticket.genericCostInCents/100 };
  });

  const handleSeatToggle = React.useCallback((selectedObject: SelectableObject, isAdd: boolean) => {
    if (!selectedObject.category) {
      throw new Error('BUG: ticket category missing');
    }
    const ticketOptionId = selectedObject.category.key.toString();

    const selectedSeatId = selectedObject.label;
    onSeatSelectionChange(ticketOptionId, isAdd, selectedSeatId);
  }, [onSeatSelectionChange]);

  const seatBookedModal = (
    <ActionModal
      visible={showSeatBookedModal}
      onClose={()=>setShowSeatBookedModal(false)}
      onOverlayPress={()=>setShowSeatBookedModal(false)}
      title={t('registration.seatBookedNotification')}
    />
  );

  return (
    <Box pt={30}>
      {seatBookedModal}
      <SeatsioSeatingChart
        workspaceKey={Env.getSeatIoWorkspaceKey()}
        event={eventTemplate.seatMapId}
        pricing={pricing}
        region='na'
        onObjectSelected={(object)=>handleSeatToggle(object, /* isAdd */ true)}
        onObjectDeselected={(object)=>handleSeatToggle(object, /* isAdd */ false)}
        language={i18n.language === 'zh' ? 'zh-Hans' : 'en'}
        onSelectedObjectBooked={() => setShowSeatBookedModal(true)}
        priceFormatter={(price) => `$${price.toFixed(2)}`}
        maxSelectedObjects={selectionLimiter}
      />
    </Box>
  );
};

export default SeatMap;
